const STYLES = {
  "Not Contacted": "bg-slate-100 text-slate-600 border-slate-200",
  Intro: "bg-blue-50 text-blue-700 border-blue-200",
  "Follow Up": "bg-red-50 text-[#D9232A] border-red-200",
  "Information Sent": "bg-violet-50 text-violet-700 border-violet-200",
  "Qualified Lead": "bg-emerald-50 text-emerald-700 border-emerald-200",
  Quote: "bg-amber-50 text-amber-700 border-amber-200",
  Won: "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Not Interested": "bg-rose-100 text-rose-800 border-rose-300",
  Open: "bg-amber-50 text-amber-700 border-amber-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function StageBadge({ stage, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${STYLES[stage] || STYLES["Not Contacted"]}`}>
      {stage}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 tam-fade">
      <div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0B132B]">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-2">{subtitle}</p>}
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}

export function Panel({ title, children, className = "", action, testId }) {
  return (
    <section className={`bg-white border border-slate-200 rounded-md ${className}`} data-testid={testId}>
      {title && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <h3 className="font-display font-semibold text-[#0B132B]">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </section>
  );
}

export function Pager({ page, pages, total, onPage }) {
  return (
    <div className="flex items-center justify-between text-sm text-slate-500 pt-4" data-testid="pager">
      <span>{total} records · page {page} of {pages}</span>
      <div className="flex gap-2">
        <button disabled={page <= 1} onClick={() => onPage(page - 1)} className="px-3 py-1.5 border rounded-md disabled:opacity-40 hover:bg-slate-50" data-testid="pager-prev">Prev</button>
        <button disabled={page >= pages} onClick={() => onPage(page + 1)} className="px-3 py-1.5 border rounded-md disabled:opacity-40 hover:bg-slate-50" data-testid="pager-next">Next</button>
      </div>
    </div>
  );
}
